import { useState } from 'react';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { Button, InnerPageToggleButton } from '@wajeez-web/components/ui';
import {
  useBusinessSelector,
  BusinessQuantityActions,
} from '@wajeez-web/stores/business-group';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import AddQuantityBusinessModal from './AddQuantityBusinessModal';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { DataTableWrapper } from '@wajeez-web/components/helpers';

const BusinessQuantity = ({ id, title }: { id: number; title: string }) => {
  const dispatch = useCommonDispatch();

  const [quantityModalState, setQuantityModalState] = useState(false);

  const { data, status } = useBusinessSelector(
    (state) => state.businessQuantity
  );

  const {
    tablePreferances,
    setTablePreferences,
    getData,
    isTableReferencesLoading,
  } = HandleTableData(
    'businessQuantity',
    BusinessQuantityActions.getBusinessQuantityDatatableAsync,
    undefined,
    { businessGroupId: id }
  );

  return (
    <>
      {quantityModalState && (
        <AddQuantityBusinessModal
          isOpen={quantityModalState}
          onClose={() => {
            setQuantityModalState(false);
          }}
          onSubmit={async (quantity) => {
            const res = await dispatch(
              BusinessQuantityActions.createnewBusinessQuantityAsync({
                quantity,
                businessGroupId: Number(id),
              })
            );
            if (res.meta.requestStatus === 'fulfilled') {
              setQuantityModalState(false);
              getData();
            }
          }}
          data={0}
        />
      )}
      <div className="space-y-6">
        <div className="flex justify-between">
          <div>
            <h3 className="ms-2 lg:ms-0 text-2xl flex align-middle font-bold space-s-2 tracking-tight leading-none  ">
              {<InnerPageToggleButton />} <div className="mt-1">{title}</div>
            </h3>
            <p className=" text-sm text-gray-600"></p>
          </div>
          <Button
            title={'Add New Quantity'}
            onClick={() => setQuantityModalState(true)}
          />
        </div>
        <DataTableWrapper
          data={data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={status === 'loading'}
          preferences={tablePreferances || undefined}
          setPreferences={setTablePreferences}
        />
      </div>
    </>
  );
};

export default BusinessQuantity;
